import { z, isoZ } from 'my-zod'
import { productLineOptions } from '../../internal/product-lines'

export const damageWaiverAgreementsModel = z.object({
  id: z.number(),
  operatorId: z.number().nullable(),
  productLine: z.enum(productLineOptions),
  damageWaiverAgreement: z.string().nonempty(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type damageWaiverAgreementsModel = z.infer<typeof damageWaiverAgreementsModel>
